import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cursor-default" }
const _hoisted_2 = { class: "d-flex flex-column mt-2" }
const _hoisted_3 = { class: "d-flex py-1" }
const _hoisted_4 = { class: "w-75" }
const _hoisted_5 = { class: "d-flex py-1" }
const _hoisted_6 = { class: "w-75" }
const _hoisted_7 = { class: "d-flex py-1" }
const _hoisted_8 = { class: "w-75" }
const _hoisted_9 = { class: "d-flex py-1" }
const _hoisted_10 = { class: "w-75" }
const _hoisted_11 = { class: "d-flex py-1" }
const _hoisted_12 = { class: "w-75" }
const _hoisted_13 = { class: "d-flex py-1" }
const _hoisted_14 = { class: "w-75" }
const _hoisted_15 = { class: "d-flex py-1" }
const _hoisted_16 = { class: "w-75" }
const _hoisted_17 = { class: "d-flex py-1" }
const _hoisted_18 = { class: "w-75" }
const _hoisted_19 = { class: "d-flex py-1" }
const _hoisted_20 = { class: "w-75" }
const _hoisted_21 = { class: "d-flex py-1" }
const _hoisted_22 = { class: "w-75" }
const _hoisted_23 = { class: "d-flex py-1" }
const _hoisted_24 = { class: "w-75" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, [
      _createElementVNode("b", null, _toDisplayString(_ctx.$t("keyboard_shortcuts")), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "w-25" }, [
          _createElementVNode("kbd", null, "1"),
          _createTextVNode(),
          _createElementVNode("kbd", null, "2"),
          _createTextVNode(),
          _createElementVNode("kbd", null, "3")
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("kb_show_filters")), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "w-25" }, [
          _createElementVNode("kbd", null, "/")
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("kb_focus_search")), 1 /* TEXT */)
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "py-3" }, null, -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_7, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-25" }, [
          _createElementVNode("kbd", null, "j"),
          _createTextVNode(),
          _createElementVNode("kbd", null, "k")
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("kb_next_prev_article")), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "w-25" }, [
          _createElementVNode("kbd", null, "l"),
          _createTextVNode(),
          _createElementVNode("kbd", null, "h")
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("kb_next_prev_feed")), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "w-25" }, [
          _createElementVNode("kbd", null, "q")
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("kb_close_article")), 1 /* TEXT */)
      ]),
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "py-3" }, null, -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_13, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "w-25" }, [
          _createElementVNode("kbd", null, "R")
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("kb_mark_all_read")), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "w-25" }, [
          _createElementVNode("kbd", null, "r")
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("kb_mark_read")), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "w-25" }, [
          _createElementVNode("kbd", null, "s")
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("kb_mark_starred")), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "w-25" }, [
          _createElementVNode("kbd", null, "o")
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("kb_open_link")), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "w-25" }, [
          _createElementVNode("kbd", null, "i")
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("kb_read_here")), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "w-25" }, [
          _createElementVNode("kbd", null, "f"),
          _createTextVNode(),
          _createElementVNode("kbd", null, "b")
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("kb_scroll_content")), 1 /* TEXT */)
      ])
    ])
  ]))
}